import { Dropdown } from 'bootstrap';

const filter = document.querySelector('.c-posts-filter');
const filterButton = document.querySelector('.c-posts-filter__button');
const buttonClose = document.querySelector('.c-posts-filter__close');
const buttonApply = document.querySelector('.c-posts-filter__apply');
const dropdownWrapper = document.querySelector('.c-posts-filter');

const dropdown = new Dropdown(filterButton);

if (buttonClose) {
  buttonClose.addEventListener('click', () => {
    dropdown.hide();
  });
}

function getTerms(taxonomyName) {
  let url = '';
  const terms = [];
  const termsElements = document.querySelectorAll(`.c-posts-filter__list--${taxonomyName} input:checked`);

  if (termsElements) {
    termsElements.forEach((item) => {
      terms.push(item.id);
    });
  }

  if (terms.length > 0) {
    url = `/${taxonomyName}/${terms.join(',')}`;
  }

  return url;
}

buttonApply.addEventListener('click', () => {
  let href = getTerms('category') + getTerms('destinations');

  href = filter.dataset.blogUrl + href.slice(1);

  window.location.href = href;
});

function checkTerms(taxonomyName) {
  const url = window.location.href;
  const regexp = new RegExp(`${taxonomyName}/([a-z0-9-,]+)`, 'g');
  let termsChecked = [];

  const matchesTerms = [...url.matchAll(regexp)];
  if (matchesTerms[0] && matchesTerms[0][1]) {
    termsChecked = matchesTerms[0][1].split(',');
  }

  const termsElements = document.querySelectorAll(`.c-posts-filter__list--${taxonomyName} input`);
  if (termsElements) {
    termsElements.forEach((item) => {
      if (termsChecked.includes(item.id)) {
        // eslint-disable-next-line no-param-reassign
        item.checked = true;
      }
    });
  }
}

dropdownWrapper.addEventListener('show.bs.dropdown', () => {
  checkTerms('category');
  checkTerms('destinations');
});
